import { useEffect, useState } from "react";
import axios from 'axios';
import Title from './Title'
import Loading from './Loading'
import Button from './Button'
import Frame from './Frame'

function Home() {
    const [streams, setStreams] = useState([]);
    const [fetched, setFetched] = useState(false);
    const [selectedStream, setSelectedStream] = useState(null);
    const [call, setCall] = useState(false);
    const [popText, setPopText] = useState('Pop-!');

    const randomPlay = () => {
        if (streams.length === 0) {
            alert("방송을 불러오는 중입니다. 이 작업은 최대 30초까지 소요됩니다.");
            return;
        }

        const randomIndex = Math.floor(Math.random() * streams.length);
        const randomStream = streams[randomIndex];
        setSelectedStream(randomStream);

        setPopText(current => "Re" + current);
        setCall(true);
    };
    const visitStreamer = () => {
        window.open(`https://chzzk.naver.com/live/${selectedStream.channelId}`, '_blank');
    };

    useEffect(() => {
        const fetchStreams = async () => {
            try {
                const response = await axios.get("https://pickle-0stream.onrender.com/api/streams");
                // const response = await axios.get("http://localhost:4000/api/streams");

                if (response.data.success) {
                    setStreams(response.data.streams);
                    setFetched(true);
                } else {
                    console.error("백엔드 데이터 오류:", response.data.message);
                }
            } catch (error) {
                console.error("백엔드 서버 연결 실패:", error);
            }
        };

        fetchStreams();
    }, []);

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            maxWidth: "640px",
            width: "calc(100vw - 20px)",
        }}>
            <Title />
            <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "right",
                marginBottom: "-10px",
            }}>
                <Loading fetched={fetched} />
            </div>
            <Frame selectedStream={selectedStream} />
            <Button name={popText} onClick={randomPlay} bgColor={fetched? "#00FFA3" : "#606060"} color={"#141414"} weight={"900"} />
            {call ?
                <div className="centerBox streamerBox" style={{
                    gap: "20px",
                    backgroundColor: "#303030",
                    padding: "10px 10px 10px 20px",
                    borderRadius: "8px",
                }}>
                    <div className="streamInfo" style={{ fontSize: "20px", }}>
                        <div className="streamTitle" style={{
                            maxWidth: "410px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            marginBottom: "5px",
                        }}>{selectedStream.liveTitle}</div>
                        <div><b>@{selectedStream.channelName}</b></div>
                    </div>
                    <Button name={"스트리밍 방문하기"} onClick={visitStreamer} bgColor={"#000000"} color={"white"} weight={"400"} />
                </div>
                : ''
            }
            <div style={{
                width: "100%",
                fontSize: "14px",
                marginTop: "10px",
            }}>
                <b>이용 주의 사항</b><br />
                무작위로 제공되는 방송에는 부적절하거나 건강하지 않은 내용이 포함될 수 있습니다. 방송의 내용은 럭키 제로스트림 피커와 무관하며, 본 서비스는 내용의 적합성을 보장하지 않습니다. 시청 시 사용자의 주의가 필요합니다.
            </div>
        </div>
    );
}

export default Home;